import { useEffect, type RefObject } from 'react';

// Closing an overlay the way a shopper expects to: Escape, or a tap anywhere that is not it. Shared by
// every element that opens something over the page — the menu's folded list, the search field — because
// the second one of those to be written is the moment this stops being one element's business.

// Closes an open overlay when the shopper presses Escape or points at anything outside it.
export function useCloseOutside(host: RefObject<HTMLElement | null>, open: boolean, close: () => void): void {
  useEffect(() => {
    if (!open) return;
    const onPointer = (event: PointerEvent) => { if (!host.current?.contains(event.target as Node)) close(); };
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape') close(); };
    document.addEventListener('pointerdown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [host, open, close]);
}
